import { Spinner } from "@fluentui/react-components";
import { useEffect, useState } from "react";
import { NoDataCard } from "../../../components-v2/common/no-data-card/NoDataCard";
import WeatherEnum from "../../../enum/WeatherEnum";
import { useApiResource } from "../../../hooks/useApiResource";
import { IRunwayWind } from "../../../models/weather/IRunwayWind";
import {
  AIRPORT_CODE_PARAMETER,
  EMPTY_STATE_MESSAGE,
} from "../../../utils/common/Constants";
import { runwayImages } from "../../../utils/weather/WeatherConstants";
import { AmdTabs } from "../../common/tabs/tabs";
import { RunwayWindCard } from "./RunwayWindCard";
export interface IRunwayWindProps {
  airport: string;
}

const getRunwayBaseUrl = process.env.REACT_APP_API_RUNWAYS;
const getRunwayWindDetailsBaseUrl =
  process.env.REACT_APP_API_RUNWAY_WIND_INFORMATION;

const RunwayWind: React.FunctionComponent<IRunwayWindProps> = ({ airport }) => {
  const [selectedRunway, setSelectedRunway] = useState<string | null>(null);

  const getRunwayUrl = `${getRunwayBaseUrl?.replace(
    AIRPORT_CODE_PARAMETER,
    airport
  )}`;

  const baseUrl =
    getRunwayWindDetailsBaseUrl?.replace(AIRPORT_CODE_PARAMETER, airport) ?? "";
  const getRunwayWindDetailsUrl = selectedRunway
    ? `${baseUrl}/${selectedRunway}`
    : baseUrl;
  const { data: runwayResponseData = [] } = useApiResource<string[]>({
    queryKey: ["runway", airport],
    url: getRunwayUrl,
  });
  const {
    data: runwayWindDetails,
    error,
    isLoading,
  } = useApiResource<IRunwayWind>({
    url: getRunwayWindDetailsUrl,
    queryKey: selectedRunway ? [airport, selectedRunway] : [airport],
    enabled: !!selectedRunway,
  });
  useEffect(() => {
    if (runwayResponseData && runwayResponseData.length > 0) {
      setSelectedRunway(runwayResponseData[0]);
    }
  }, [runwayResponseData]);

  const runawayTabs =
    runwayResponseData.length > 0
      ? runwayResponseData.map((runway: string) => ({
          text: runway,
          name: runway,
          value: runway,
        }))
      : [];

  const onSelectRunway = (_runway: string) => {
    setSelectedRunway(_runway);
  };
  const getRunwayImage = (runway: string | null): string => {
    if (!runway) return "";
    try {
      return runwayImages[runway] ?? "";
    } catch (error) {
      console.warn(`Image not found for runway: ${runway}`);
      return "";
    }
  };

  const runwayImageSrc = getRunwayImage(selectedRunway);
  return (
    <div className="amd-section-shadow mt-2" data-testid="runway-wind">
      <header className="amd-section-shadow__header amd-section-shadow__header--lg">
        <span>Runway Wind</span>
      </header>
      <AmdTabs
        dataTestId="RunwayWindTab"
        defaultSelectedTab={selectedRunway ?? ""}
        tabList={runawayTabs}
        onTabClick={onSelectRunway}
        selectedTab={selectedRunway ?? ""}
      />
      {error && <NoDataCard message={EMPTY_STATE_MESSAGE.Data} />}
      {isLoading && (
        <Spinner
          labelPosition="below"
          label="Loading..."
          style={{ minHeight: "307px" }}
        />
      )}
      {!error && !isLoading && runwayWindDetails && (
        <RunwayWindCard
          viewType={WeatherEnum.RunwayViewType.Runway}
          runwayWindDetails={runwayWindDetails}
          runwayImg={runwayImageSrc}
        />
      )}
    </div>
  );
};

export default RunwayWind;
